import { Locale } from '@longy/common'
import { BlockDefinitionArray } from '@longy/common/cms'

import { BlocksRenderer } from '../blocks/BlocksRenderer'
import { RendererProvider, RendererProviderProps } from '../context/RendererContext'

export type PageRendererProps = Omit<RendererProviderProps, 'children'> & {
    blocks: BlockDefinitionArray
    locale: Locale
}

/**
 * One page's blocks, with the environment they need.
 *
 * Both the public site and the admin preview mount exactly this, which is what makes "what you see
 * is what ships" true by construction rather than by discipline.
 */
export const PageRenderer = ({ blocks, ...context }: PageRendererProps) => (
    <RendererProvider {...context}>
        <BlocksRenderer blocks={blocks} />
    </RendererProvider>
)
